import { Organisation } from "../models/organisation";
import axiosConfig from "./axiosConfig";

const postOrganisation = async (
  authToken: string,
  org: { organisation: Partial<Organisation> }
): Promise<Organisation> => {
  const { data } = await axiosConfig.post("/organisation", org, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default postOrganisation;
